<template>
  <v-container class="wrapper">
    <div>
      <p class="sub-title">{{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.SUMMARY') }}</p>

      <!--OFFERS LIST-->
      <div class="mb-3">
        <div
          :key="repairerOffer"
          v-for="repairerOffer of currentRepairFile?.repairer_estimate
            ?.repairer_estimate_option_list"
          class="repairer-offer-content"
        >
          <p>{{ $t('COMMON.PRODUCT_END_STATUS.' + repairerOffer.offer_type.toUpperCase()) }}</p>
          <p class="price-text">{{ repairerOffer.total_cost.toFixed(2) + $t('COMMON.EURO') }}</p>
        </div>

        <!--BACK BUTTON-->
        <v-btn
          class="back-button button w-100"
          :loading="loading"
          variant="outlined"
          @click="backToRepairerOffersCreation()"
        >
          <v-icon icon="mdi-chevron-left"></v-icon>
          {{ $t('COMMON.BUTTON.BACK') }}
        </v-btn>
      </div>

      <p class="sub-title">{{ $t('ESTIMATE_REPAIRER_DETAIL.SUB_TITLE.INFORM_CLIENT') }}</p>

      <!-- PHONE NUMBER -->
      <p class="text-field">{{ $t('ESTIMATE_REPAIRER_DETAIL.CALL_CLIENT') }}</p>
      <div class="phone-content">
        <img src="@/assets/icons/file/phone.svg" alt="phone-icon" class="phone-icon" />
        <p>{{ currentRepairFile?.phone_number }}</p>
      </div>

      <!-- EMAIL -->
      <p class="text-field">{{ $t('ESTIMATE_REPAIRER_DETAIL.SEND_ESTIMATE') }}</p>
      <v-text-field
        required
        v-model="email"
        :rules="[...requiredRules, ...emailRules]"
        append-inner-icon="mdi-pencil-outline"
      >
        <template v-slot:prepend-inner>
          <img src="@/assets/icons/file/mail.svg" alt="mail-icon" class="mail-icon" />
        </template>
      </v-text-field>

      <v-btn
        class="boom-button email-button w-100"
        :disabled="loading"
        :loading="loading"
        variant="outlined"
        @click="sendClientEmail"
      >
        <p>{{ $t('ESTIMATE_REPAIRER_DETAIL.BUTTON.SEND_EMAIL') }}</p>
      </v-btn>
    </div>
    <div class="bottom-content">
      <v-col cols="12" class="px-0">
        <v-btn
          class="button w-100"
          :disabled="loading"
          :loading="loading"
          variant="outlined"
          @click="submitSaveEmail()"
        >
          <p>{{ $t('COMMON.BUTTON.CONTINUE') }}</p>
        </v-btn>
      </v-col>
      <v-btn
        class="button w-100"
        :loading="loading"
        variant="outlined"
        @click="$emit('cancelEstimateRepairer')"
      >
        {{ $t('ESTIMATE_REPAIRER_DETAIL.BUTTON.CANCEL') }}
      </v-btn>
    </div>
  </v-container>
</template>
<script>
import ResponseConstant from '@/constants/responseConstant'
import { auth as $store } from '@/store/AuthModule'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'
import RepairFileService from '@/services/RepairFileService'
import EstimateRepairerService from '@/services/EstimateRepairerService'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      loading: false,
      error: null,

      requiredRules: Validator.requiredRules,
      emailRules: Validator.emailRules,

      email: null,
      repairer_estimate_option_list: null
    }
  },
  created() {
    this.patchData()
  },
  methods: {
    async submitSaveEmail() {
      if (this.email !== this.currentRepairFile.email) {
        this.loading = true
        try {
          const data = {
            requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
            repair_file_id: this.currentRepairFile.technical_id,
            contact_email: this.email
          }
          await RepairFileService.updateRepairFileEmail(data)
          displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.CUSTOMER_EMAIL_SAVE'), 'success')
        } catch (error) {
          handleResponseError(error)
          if (error.response?.data && error.response.data.key in ResponseConstant) {
            this.setError(error.response.data.key)
          }
        } finally {
          this.loading = false
          this.$emit('updateCurrentRepairFile')
          this.$emit('openEstimateRepairerClientChoice')
        }
      }
      this.$emit('openEstimateRepairerClientChoice')
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    setError(key) {
      switch (key) {
        case 'invalid_repairer_repair_file_number_error_key':
          this.error = { repairerNumber: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    },
    patchData() {
      this.email = this.currentRepairFile?.email
    },
    async sendClientEmail() {
      this.loading = true
      try {
        const data = {
          requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
          repair_file_id: this.currentRepairFile.technical_id,
          contact_email: this.email
        }
        await RepairFileService.sendRepairFileRepairerEstimateToClient(data)
        displayToast(this.$t('ESTIMATE_REPAIRER_DETAIL.MODAL.SEND_CLIENT_EMAIL'), 'success')
        this.$emit('updateCurrentRepairFile')
        this.$emit('closeNewAction')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    },
    async backToRepairerOffersCreation() {
      this.loading = true
      try {
        await EstimateRepairerService.backToRepairerOffersCreation(
          this.currentRepairFile.technical_id
        )
        this.$emit('backToRepairerOffersCreation')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
}

.text-field {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.button {
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  text-transform: none !important;
  border-radius: 20px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.email-button {
  margin-bottom: 20px;
}

.boom-button {
  padding: 10px 20px !important;
}

:deep(.v-infinite-scroll__side) {
  padding: unset;
}

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.bottom-content {
  margin-top: auto;
}

.repairer-offer-content {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  border-radius: 20px;
  border: 1px solid #559a1b;
  background: #fafafa;
  margin-bottom: 20px;
}

.price-text {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.phone-icon {
  width: 20px;
  height: 20px;
  margin-right: 16px;
  filter: invert(0%) sepia(100%) saturate(7461%) hue-rotate(61deg) brightness(106%) contrast(109%);
}

.mail-icon {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-right: 10px;
  filter: invert(0%) sepia(100%) saturate(7461%) hue-rotate(61deg) brightness(106%) contrast(109%);
}

.phone-content {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 10px 20px 10px 20px;
  border-radius: 30px;
  border: 1px solid #dedede;
}

.back-button {
  border: 1px solid #dedede;
  max-width: max-content;
  padding: 2px 15px 2px 10px;
}
</style>
